import React from "react";

/**
 * Compact SVG icon that mirrors the OperatorWheel spinner visual.
 * Uses currentColor so it inherits button/pill text colour.
 */
export const WheelIcon = ({ size = 14, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    className={className}
  >
    {/* Outer ring */}
    <circle cx="12" cy="13" r="8" />
    {/* Inner hub */}
    <circle cx="12" cy="13" r="2" fill="currentColor" stroke="none" />
    {/* Spokes — 8 evenly spaced */}
    <line x1="12" y1="5" x2="12" y2="7.5" />
    <line x1="12" y1="18.5" x2="12" y2="21" />
    <line x1="4" y1="13" x2="6.5" y2="13" />
    <line x1="17.5" y1="13" x2="20" y2="13" />
    <line x1="6.34" y1="7.34" x2="8.11" y2="9.11" />
    <line x1="15.89" y1="16.89" x2="17.66" y2="18.66" />
    <line x1="17.66" y1="7.34" x2="15.89" y2="9.11" />
    <line x1="8.11" y1="16.89" x2="6.34" y2="18.66" />
    {/* Pointer above the wheel */}
    <polygon points="10,2 14,2 12,4.5" fill="currentColor" stroke="none" />
  </svg>
);

export default WheelIcon;
